/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { DBSchema, OpenDBCallbacks } from "idb";
import { UserSimple } from '../../redux/users';
import { DairyFARMDB } from "../store";
import { Coop } from "./coops";

export const FACILITIES_STORE = "facilities" as "facilities";

export interface FacilityGroup {
  name: string;
  id: string;
}

export interface Farm {
  id: string;
  name: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  customIds?: string[];
  hasMultipleFacilities: boolean;
  managers: UserSimple[];
}

export interface Facility {
  id: string;
  name: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  premise_id?: string;
  manager?: string;
  email?: string;
  phone?: string;
  fax?: string;
  type?: string[];
  updated?: string;
  customIds?: string[];
  managers: UserSimple[];
  farm: Farm;
  coop?: Coop;
  groups?: FacilityGroup[],
  status: 'active' | 'probation' | 'suspended';
  /**
   * Pilot programs that the facility can access
   */
  programs: string[];
}

/**
 * @deprecated facilities will be stored in redux-persist. This table should remain empty
 */
export interface FacilitiesStore extends DBSchema {
  [FACILITIES_STORE]: {
    key: string;
    value: Facility;
  };
}

export const facilitiesStoreConfig: OpenDBCallbacks<DairyFARMDB> = {
  upgrade(db, oldVersion, newVersion, transaction) {
    if (!db.objectStoreNames.contains(FACILITIES_STORE)) {
      db.createObjectStore(FACILITIES_STORE, {
        keyPath: "id",
      });
    }
  },
};
